import { Avatar, Divider, Grid, Typography } from "@mui/material";

interface IProps {
  order: string;
  text: string;
}

export function PresentationHeader({ order, text }: IProps) {
  return (
    <Grid container direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <Grid item xs="auto">
        <Avatar
          sx={{
            width: 25,
            height: 25,
            fontSize: 12,
            fontWeight: 600,
            backgroundColor: "neutral500.main",
            color: "neutral0.main",
          }}
        >
          {order}
        </Avatar>
      </Grid>
      <Grid item xs="auto">
        <Typography
          variant="body1"
          fontWeight={600}
          color="neutral1000.main"
          sx={{ whiteSpace: "nowrap" }}
        >
          {text}
        </Typography>
      </Grid>
      <Grid item xs>
        <Divider
          sx={{
            backgroundColor: "neutral500.main",
            width: "100%",
            height: "1px",
          }}
        />
      </Grid>
    </Grid>
  );
}
